<template>
  <div class="app-development">
    <div class="nav-left">
      <el-input placeholder="搜索" v-model="filterText">
        <template #prefix>
          <img
            src="@/assets/img/nav_search.png"
            alt="search"
            style="
              width: 16px;
              height: 16px;
              margin-top: 10px;
              margin-left: 8px;
            "
          />
        </template>
      </el-input>

      <el-tree
        class="filter-tree"
        :data="data"
        :props="defaultProps"
        default-expand-all
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
        ref="tree"
        node-key="id"
      >
        <template #default="{ data }">
          <div
            :class="{
              tree_text: true,
              'text-is-current': data.path === $route.path,
              tree_text_long: data.label.length > 22,
            }"
          >
            <span>{{ data.label }}</span>
          </div>
        </template>
      </el-tree>
    </div>
    <div class="content">
      <MarkdownView :textData="textData" />
    </div>
  </div>
</template>

<script>
import MarkdownView from "@/components/MarkdownView.vue";
import { deviceDoc } from "@/data/deviceDoc";

export default {
  name: "DeviceView",
  components: {
    MarkdownView,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    $route(to, from) {
      console.log("to", to.path);
      console.log("from", from.path);
      this.textData = this.findNodeByPath(this.data, to.path)?.data || "";
    },
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(node) {
      if (node.path && this.$route.path !== node.path) {
        this.$router.replace(node.path);
      }
    },
    findNodeByPath(data, path) {
      for (const item of data) {
        if (item.path === path) {
          return item;
        }
        if (item.children) {
          const found = this.findNodeByPath(item.children, path);
          if (found) return found;
        }
      }
      return null;
    },
  },

  mounted() {
    console.log("this.$route.path", this.$route.path);
    this.textData =
      this.findNodeByPath(this.data, this.$route.path)?.data || "";
  },

  data() {
    return {
      filterText: "",
      data: deviceDoc,
      defaultProps: {
        children: "children",
        label: "label",
        key: "id", // 设置key字段
      },
      textData: "",
    };
  },
};
</script>

<style scoped>
.filter-tree {
  margin-top: 32px;
  font-weight: 500;
  font-size: 14px;
  color: #1f2937;
  text-align: left;
}

::v-deep .nav-left .el-input__inner::placeholder {
  font-weight: 500;
  font-size: 15px;
  text-align: left;
  color: #6b7280;
  padding-left: 8px;
}

::v-deep .filter-tree .el-tree-node__content:hover {
  background-color: transparent;
}

::v-deep .filter-tree .el-tree-node__content {
  background-color: #fff !important;
  height: 36px;
}

.app-development {
  display: flex;
  width: 100%;
  height: 100%;
}

.nav-left {
  width: 25%;
  max-width: 380px;
  padding: 20px;
  border-right: 1px solid #e5e7eb;
}

.tree_text {
  width: 100%;
  height: 32px;
  line-height: 16px;
  text-align: left;
  padding: 0 10px;
  border-radius: 4px;
  word-wrap: break-word; /* 强制换行，避免单词超出容器 */
  word-break: break-word; /* 强制在长单词或URL等处断开 */
  white-space: normal; /* 允许多行文本 */
  display: flex;
  align-items: center;
}

/* .tree_text_long {
  width: 100%;
  height: 36px;
  line-height: 18px;
  word-wrap: break-word; 
  word-break: break-word; 
  white-space: normal; 
} */

.tree_text:hover {
  background-color: #f3f4f6;
}

.tree_text.text-is-current {
  background-color: #f3f4f6;
}

.content {
  flex: 1;
  width: 75%;
}
</style>
